import { render, staticRenderFns } from "./VoicebotCallDurationDistributionChart.vue?vue&type=template&id=8ccb8ab6&scoped=true"
import script from "./VoicebotCallDurationDistributionChart.vue?vue&type=script&lang=js"
export * from "./VoicebotCallDurationDistributionChart.vue?vue&type=script&lang=js"
import style0 from "./VoicebotCallDurationDistributionChart.vue?vue&type=style&index=0&id=8ccb8ab6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ccb8ab6",
  null
  
)

export default component.exports